import React, { useCallback } from "react";
import HeroButton from "/app/src/components/HeroUi/Button";
import { useTranslation } from "react-i18next";
import { App } from "/app/src/models";
export default function Controls({
  app,
  toggleNew,
  activeNew,
}: {
  app: App;
  toggleNew: () => void;
  activeNew: boolean;
}) {
  const { t } = useTranslation();

  const toggleNewDisplay = useCallback(() => {
    toggleNew();
  }, [toggleNew]);

  return (
    <div className="controls">
      <div className="icon"> </div>
      <div className="title">{app && <h1>{app.name}</h1>}</div>

      <div className="controlButtons">
        {activeNew ? (
          <HeroButton
            color="primary"
            variant="bordered"
            onClick={toggleNewDisplay}
            size="sm"
          >
            {t("translation:cancel")}
          </HeroButton>
        ) : (
          <HeroButton color="primary" size="sm" onClick={toggleNewDisplay}>
            {t("translation:new_display")}
          </HeroButton>
        )}
      </div>
    </div>
  );
}
